import { useState } from 'react'

export const useCompletedRoutes = (
	key: string,
): {
	completedRoutes: string[]
	addCompletedRoute: (route: string) => void
	isRouteCompleted: (route: string) => boolean
	clearCompletedRoutes: () => void
} => {
	const [completedRoutes, setCompletedRoutes] = useState<string[]>(() => {
		const savedRoutes = localStorage.getItem(key)
		return savedRoutes ? JSON.parse(savedRoutes) : []
	})

	const addCompletedRoute = (route: string) => {
		if(completedRoutes.includes(route)) {
			return
		}
		
		setCompletedRoutes((prevRoutes) => {
			const updatedRoutes = [...prevRoutes, route]
			localStorage.setItem(key, JSON.stringify(updatedRoutes))
			return updatedRoutes
		})
	}

	const clearCompletedRoutes = () => {
		localStorage.removeItem(key)
		setCompletedRoutes([])
	}

	const isRouteCompleted = (route: string) => completedRoutes.includes(route)

	return {
		completedRoutes,
		addCompletedRoute,
		isRouteCompleted,
		clearCompletedRoutes,
	}
}
